import React from 'react';
import {cssTransition, toast} from "react-toastify/esm/react-toastify";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import ValidationMessages from "../refactor/ValidationMessages.jsx";

const notification = ({id, message, ...rest}) => {
  toast.dismiss(id);
  const transition = cssTransition({
    enter: 'fadeIn',
    exit: 'fadeOut',
    duration: [500, 0],
    appendPosition: false
  });
  toast(message, {
    autoClose: false,
    className: 'ignite-notification',
    closeButton: <i className="fa fa-times-circle close-button" role="img" aria-label="Close" />,
    draggable: false,
    toastId: id,
    transition,
    ...rest
  });
};

export const NotificationMessage = ({className, icon, message, renderAfter, renderBefore, title}) => {
  const cssBEM = 'notificationMessages';
  const listOfMessages = Array.isArray(message) ? message : [message];
  const messages = listOfMessages.map((m, index) => <div key={index} className={`${cssBEM}__message`}>{m}</div> );
  return <div className={`${cssBEM} ${className}`}>
    { title ? <h4 className={`${cssBEM}__title`}>{icon}{title}</h4> : null }
    { renderBefore ? renderBefore : null }
    { messages }
    { renderAfter ? renderAfter : null }
  </div>
};
NotificationMessage.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.element,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.array,
  ]).isRequired,
  renderAfter: PropTypes.element,
  renderBefore: PropTypes.element,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ])
};

export const notifyValidationErrors = validationErrors => {
  const message = <NotificationMessage
    icon={<i className="ion-alert-circled"/> }
    title={<FormattedMessage id="error.title"/>}
    message={<ValidationMessages validationErrors={validationErrors || []}/>}
  />;

  notification({
    id: 'validationErrors',
    message,
    type: toast.TYPE.ERROR,
    autoClose: 10000
  });
};

export const notifySuccess = id => {
  const message = <NotificationMessage
    icon={<i className="ion-ios-checkmark-outline"/>}
    title={<FormattedMessage id={`${id}.success.title`} />}
    message={<FormattedMessage id={`${id}.success.message`} />}
  />;
  notification({
    id,
    message,
    type: toast.TYPE.SUCCESS
  });
};

export const notifyInfo = id => {
  const message = <NotificationMessage
    icon={<i className="ion-ios-information-outline"/>}
    title={<FormattedMessage id={`${id}.info.title`} />}
    message={<FormattedMessage id={`${id}.info.message`} />}
  />;
  notification({
    id,
    message,
    type: toast.TYPE.INFO
  });
};

export const notifyError = id => {
  const message = <NotificationMessage
    icon={<i className="ion-alert-circled"/>}
    title={<FormattedMessage id={`${id}.error.title`} />}
    message={<FormattedMessage id={`${id}.error.message`} />}
  />;
  notification({
    id,
    message,
    type: toast.TYPE.ERROR
  });
};

export const clearNotifications = () => {
  toast.dismiss()
};

export default notification;
